import { checkEstimatePassengerCount, ESTIMATE_PASSENGER_COUNT_ERROR } from '@massilia/contracts';
import { z } from 'zod';
import { airportOptionSchema, clientFirstNameSchema, clientLastNameSchema, contactEmailSchema, contactPhoneSchema, flexibilityDaysSchema, futureDateSchema, newPassengerSchema, pensionSchema, tourismSchema, travelClassSchema, } from './base-schemas';
// =====================================================================
// TOURISM ESTIMATE SCHEMAS
// Validation schemas for tourism estimate forms with French error messages
// =====================================================================
// ---- Tourism Estimate Form Base Schema ----
// Object schema without refinements (for extension)
const tourismEstimateFormBaseFields = {
    clientFirstName: clientFirstNameSchema,
    clientLastName: clientLastNameSchema,
    contactEmail: contactEmailSchema,
    approximativeBudget: z.coerce
        .number()
        .min(1, 'Budget requis')
        .positive('Budget doit \u00eatre positif'),
    carLoan: z.boolean(),
    complementaryInformation: z.string(),
    contactPhoneNumber: contactPhoneSchema,
    departure: airportOptionSchema,
    departureDate: futureDateSchema,
    departureFlexibilityAfter: flexibilityDaysSchema,
    departureFlexibilityBefore: flexibilityDaysSchema,
    destination: airportOptionSchema,
    // New split passenger structure
    existingPassengerIds: z.array(z.string()).optional(),
    hotelMinimumNumberOfStars: z.coerce
        .number()
        .int()
        .min(1, 'Minimum 1 \u00e9toile')
        .max(5, 'Maximum 5 \u00e9toiles')
        .nullable(),
    maxStayDuration: z.coerce.number().int().min(0).optional(),
    newPassengers: z.array(newPassengerSchema).optional(),
    onSiteActivities: z.boolean(),
    pension: pensionSchema,
    returnDate: futureDateSchema,
    returnFlexibilityAfter: flexibilityDaysSchema,
    returnFlexibilityBefore: flexibilityDaysSchema,
    transfertFromAirport: z.boolean(),
    travelClass: travelClassSchema,
    type: tourismSchema,
};
// ---- Tourism Estimate Schema with estimateType for Discriminated Union ----
export const tourismEstimateSchema = z
    .object({
    ...tourismEstimateFormBaseFields,
    estimateType: z.literal('TOURISM'),
})
    .refine((data) => {
    const returnDate = new Date(data.returnDate);
    const departureDate = new Date(data.departureDate);
    return returnDate > departureDate;
}, {
    message: 'Date de retour doit être après date de départ',
    path: ['returnDate'],
})
    .refine(checkEstimatePassengerCount, ESTIMATE_PASSENGER_COUNT_ERROR);
